import { Calendar, CalendarProps } from '@e2n/ui';
import { useOpenToDosForDatePicker } from '../../hooks/useOpenTodosForDatePicker';
import dayjs from 'dayjs';
import { DayContent } from './DayContent';
import { useStandortContext } from '@/features/standortContext/StandortContext';

// eslint-disable-next-line max-lines-per-function
export default function DatePicker({
  date,
  onSelect,
  currentMonth,
  setCurrentMonth,
  ...calendarProps
}: {
  date: Date;
  onSelect: (date: Date) => void;
  currentMonth: Date;
  setCurrentMonth: (month: Date) => void;
} & CalendarProps) {
  const {
    currentStandort: { id: standortId },
  } = useStandortContext();

  const firstDayOfCurrentMonth = dayjs(currentMonth).startOf('month').toDate();
  const lastDayOfCurrentMonth = dayjs(currentMonth).endOf('month').toDate();
  const von = dayjs(firstDayOfCurrentMonth)
    .subtract(1, 'week')
    .format('YYYY-MM-DD');
  const bis = dayjs(lastDayOfCurrentMonth).add(1, 'week').format('YYYY-MM-DD');

  const { openToDosByDate } = useOpenToDosForDatePicker(von, bis, standortId);

  return (
    <Calendar
      {...calendarProps}
      classNames={{
        head_cell: 'text-neutrals-600 w-9 font-normal text-xs',
        day_outside: 'text-neutrals-600',
      }}
      mode="single"
      selected={date}
      onSelect={(d) => {
        onSelect(d);
      }}
      defaultMonth={date}
      onMonthChange={(month) => setCurrentMonth(month)}
      initialFocus
      components={{
        DayContent: (props) => {
          const hasOpenTodos = openToDosByDate.find((todo) =>
            dayjs(todo.date).isSame(props.date, 'day'),
          )?.hasOpenTodos;
          return (
            <DayContent
              hasOpenTodos={hasOpenTodos}
              currentSelectedDate={date}
              {...props}
            />
          );
        },
      }}
    />
  );
}
